import { Box, Link } from '@mui/material'
import CompliancePlip from '../../../../components/CompliancePlip'
import dayjs from 'dayjs'
import { ComplianceStatus } from '../../../../types'
import useCustomer from '../../../../hooks/useCustomer'

interface AmalgamWasteProps {
  link: string
}

const AmalgamWaste = ({ link }: AmalgamWasteProps) => {
  const customer = useCustomer()
  const metadata = customer.customerMetadata

  return metadata && (
    <Box>
      <div className='border-box'>
        <div>
          <CompliancePlip message='' className='dashboard-compliance' status={metadata.amalgam_status ?? 4} />
        </div>
        <div className='compliance-message'>
          <p className='card-info'>{metadata.amalgam_message_long}</p>
          <Link className='small-text' href={link}>{metadata.amalgam_status === ComplianceStatus.Inactive ? 'Learn More' : 'View Details'}</Link>
        </div>
      </div>
      <div className='card-footer flex justify-between'>
        {metadata.amalgam_available_containers > 0 && (
          <div className="center-text">
            <span className="block text-ot-dashboard">{metadata.amalgam_available_containers}</span>
            <span className="text-base">In Use</span>
          </div>
        )}
        {metadata.amalgam_destroyed_containers > 0 && (
          <div className="center-text">
            <span className="block text-lg">{metadata.amalgam_destroyed_containers}</span>
            <span className="text-base">Processed</span>
          </div>
        )}
        {metadata.amalgam_last_destroyed_date && (
          <div className="center-text">
            <span className="block text-lg">{dayjs(metadata.amalgam_last_destroyed_date).format('MMM D, YYYY')}</span>
            <span className="text-base">Last Activity</span>
          </div>
        )}
      </div>
    </Box>
  )
}

export default AmalgamWaste